import React from 'react';

const ContactTab = ({ register, errors, watch, setValue }) => {
  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    const numbers = value.replace(/\D/g, '');
    
    // Format the number as (xxx) xxx-xxxx
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
    } else {
      return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }
  };

  const handlePhoneChange = (e) => {
    const formattedNumber = formatPhoneNumber(e.target.value);
    setValue('primary_number', formattedNumber);
  };

  return (
    <div className="space-y-6">
      {/* Primary Phone */}
      <div>
        <label htmlFor="primaryPhone" className="block text-sm font-medium text-gray-700">
          Primary Phone Number <span className="text-red-500">*</span>
        </label>
        <div className="mt-1">
          <input
            type="tel"
            id="primary Phone"
            {...register('primary_number')}
            onChange={handlePhoneChange}
            placeholder="(xxx) xxx-xxxx"
            className={`appearance-none block w-full px-3 py-2 border ${
              errors.primary_number ? 'border-red-300' : 'border-gray-300'
            } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm`}
            
          />
          {errors.primary_number && (
            <p className="mt-2 text-sm text-red-600">{errors.primary_number.message}</p>
          )}
        </div>
      </div>

      {/* Is Mobile Phone */}
      <div>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            {...register('is_mobile_number')}
            className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
            placeholder="Enter Is Mobile Phone"
          />
          <span className="text-sm text-gray-700">This is a mobile phone number</span>
        </label>
      </div>

      {/* Show Phone to Customer */}
      <div>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            {...register('show_primary_number_to_customer')}
            className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
          />
          <span className="text-sm text-gray-700">Show this phone number to customers</span>
        </label>
      </div>

      {/* Email */}
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Email Address <span className="text-red-500">*</span>
        </label>
        <div className="mt-1">
          <input
            type="email"
            id="email"
            {...register('email')}
            className={`appearance-none block w-full px-3 py-2 border ${
              errors.email ? 'border-red-300' : 'border-gray-300'
            } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm`}
            placeholder="Enter Email Address"
          />
          {errors.email && (
            <p className="mt-2 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>
      </div>

      {/* Street Address 1 */}
      <div>
        <label htmlFor="address1" className="block text-sm font-medium text-gray-700">
          Street Address 1
        </label>
        <div className="mt-1">
          <input
            type="text"
            id="address1"
            {...register('address1')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter Street Address 1"
          />
        </div>
      </div>

      {/* Street Address 2 */}
      <div>
        <label htmlFor="address2" className="block text-sm font-medium text-gray-700">
          Street Address 2
        </label>
        <div className="mt-1">
          <input
            type="text"
            id="address2"
            {...register('address2')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter Street Address 2"
          />
        </div>
      </div>

      {/* City */}
      <div>
        <label htmlFor="city" className="block text-sm font-medium text-gray-700">
          City
        </label>
        <div className="mt-1">
          <input
            type="text"
            id="city"
            {...register('city')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter City"
          />
        </div>
      </div>

      {/* State/Province */}
      <div>
        <label htmlFor="state" className="block text-sm font-medium text-gray-700">
          State/Province
        </label>
        <div className="mt-1">
          <input
            type="text"
            id="state"
            {...register('state')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter State/Province"
          />
        </div>
      </div>

      {/* ZIP/Postal Code */}
      <div>
        <label htmlFor="zipcode" className="block text-sm font-medium text-gray-700">
          ZIP/Postal Code
        </label>
        <div className="mt-1">
          <input
            type="text"
            id="zipcode"
            {...register('zipcode')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter ZIP/Postal Code"
          />
        </div>
      </div>

      {/* Emergency Contact Section */}
      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-lg font-medium text-gray-900">Emergency Contact</h3>
        
        {/* Emergency Contact Name */}
        <div className="mt-4">
          <label htmlFor="emergency_contact_name" className="block text-sm font-medium text-gray-700">
            Emergency Contact Name
          </label>
          <div className="mt-1">
            <input
              type="text"
              id="emergency_contact_name"
              {...register('emergency_contact_name')}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
              placeholder="Enter Emergency Contact Name"
            />
          </div>
        </div>

        {/* Emergency Contact Phone */}
        <div className="mt-4">
          <label htmlFor="emergency_contact_number" className="block text-sm font-medium text-gray-700">
            Emergency Contact Phone
          </label>
          <div className="mt-1">
            <input
              type="tel"
              id="emergency_contact_number"
              {...register('emergency_contact_number')}
              onChange={(e) => {
                const formattedNumber = formatPhoneNumber(e.target.value);
                setValue('emergency_contact_number', formattedNumber);
              }}
              placeholder="(xxx) xxx-xxxx"
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
             
            />
          </div>
        </div>

        {/* Emergency Contact Relation */}
        <div className="mt-4">
          <label htmlFor="emergency_contact_relation" className="block text-sm font-medium text-gray-700">
            Relationship
          </label>
          <div className="mt-1">
            <input
              type="text"
              id="emergency_contact_relation"
              {...register('emergency_contact_relation')}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
              placeholder="Enter Emergency Contact Relation"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactTab; 